import { SecretKindEnum } from './SecretKindEnum'

/** The environment variable that holds the master key wrapping every secret row's data key. */
export const SECRET_MASTER_KEY_ENV_VAR = 'SECRET_MASTER_KEY'

/** The format version stored on a secret row's data key wrapping. */
export const DATA_KEY_FORMAT_VERSION = 1

/**
 * The fields of each secret kind, each mapped to the legacy `AppSetting` key it replaces.
 *
 * COUPLING: this map owns the legacy secret key names; the secret migrations read the legacy rows by them, so a
 * name here must keep matching the key persisted in `appsettings`.
 */
export const SECRET_FIELDS: Record<SecretKindEnum, Record<string, string>> = {
  [SecretKindEnum.Quickbooks]: { token: 'quickbooks.token' },
  [SecretKindEnum.PayrollApi]: { apiKey: 'payroll_api' },
  [SecretKindEnum.Sftp]: {
    host: 'SFTP_HOST',
    port: 'SFTP_PORT',
    user: 'SFTP_USER',
    password: 'SFTP_PASSWORD',
    directory: 'SFTP_DIRECTORY',
  },
  [SecretKindEnum.Ach]: {
    companyId: 'ACH_COMPANYID',
    accountNumber: 'ACH_ACCOUNTNUMBER',
    taxId: 'ACH_TAXID',
    abaNumber: 'ACH_ABANUMBER',
    originatorAbaNumber: 'ACH_ORIGINATORABANUMBER',
    originatorDfiNumber: 'ACH_ORIGINATORDFINUMBER',
    destinationAbaNumber: 'ACH_DESTINATIONABANUMBER',
  },
  [SecretKindEnum.PositivePay]: {
    account: 'POSITIVE_PAY_ACCOUNT',
    bankNumber: 'POSITIVE_PAY_BANKNUMBER',
  },
  [SecretKindEnum.CheckSignature]: { url: 'CHECK_SIGNATURE' },
}
